import { render, staticRenderFns } from "./TheBreadcrumb.vue?vue&type=template&id=ded8af14&scoped=true"
import script from "./TheBreadcrumb.vue?vue&type=script&lang=js"
export * from "./TheBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./TheBreadcrumb.vue?vue&type=style&index=0&id=ded8af14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded8af14",
  null
  
)

export default component.exports